<template>
  <div id="R0" class="sub">
    <div class="wrapper">
      <kg-header :headerType=1 />
      <div id="content">
        <div class="inner_static">
          <div id="register">
            <h1 class="tit1">見積書</h1>
            <div class="esti_image" v-if="isGetEstimate">
              <img :src="getPlanImage()" @error="noImage" alt="planContents">
            </div>
            <ul class="lst_register underline_ul">
              <li>
                <div class="title_text_div">
                  <label>{{orderInfo.productName}}</label>
                </div>
                <div class="cnt">
                  <p class="text_p">注文番号：<strong class="req">{{formatOrderNo(orderInfo.orderNo)}}</strong></p>
                  <section class="sec_space">
                    <ul class="lst_space">
                      <li v-for="(combine,index) in orderInfo.combineList" :key="index">
                        <span class="combine_span" @click="btnCombineClick('unit_wrap' + index)">
                          <div>
                            <div class="fl_input small_input">
                              <img class="combine_img" :src="getCombineImage(combine)" @error="noImage" alt="combineContents">
                            </div>
                            <div class="fl_input input_interval_div">&nbsp;&nbsp;&nbsp;</div>
                            <div class="fl_input">
                              <div>{{combine.objDtlTypeName}}</div>
                              <div><strong class="req">W:&nbsp;</strong>{{combine.w}}<strong class="req">&nbsp;H:&nbsp;</strong>{{combine.h}}<strong class="req">&nbsp;D:&nbsp;</strong>{{combine.d}}</div>
                              <div>{{formatPrice(roundPrice(combine.spRetailPrice4))}}</div>
                            </div>
                            <div class="cb"></div>
                          </div>
                        </span>
                        <div class="unit_wrap" v-bind:id="'unit_wrap' + index">
                        <!-- <div class="answer_wrap" v-bind:id="faq.key + index"> -->
                          <div v-for="(unit,i) in orderInfo.unitList" :key="i" >
                            <div v-if="combine.lvCombine === unit.lvCombine">
                              <div class="fl_input pair_input unit_tx">{{unit.objDtlTypeName}}</div>
                              <div class="pair_input_interval_div fl_input"></div>
                              <div class="fl_input ta_right pair_input unit_tx">{{formatPrice(roundPrice(unit.spRetailPrice4)) + ' × ' + '1' + ' = ' + formatPrice(roundPrice(unit.objTotalCostMaterial))}}</div>
                              <div class="cb"></div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </section>
                  <p class="text_p">生産者情報：</p>
                  <p class="text_p">{{orderInfo.producerName}}</p>
                  <p class="text_p">{{orderInfo.producerAddress}}</p>
                  <div class="subtotal_div">
                    <label>小計</label><div class="subtotal">{{formatPrice(orderInfo.subTotalPrice)}}</div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item">
                  <label>【オプションサービス】</label>
                </div>
                <div class="cnt">
                  <p class="att">必要なオプションにチェックしてください。</p>
                  <p class="att">金額が再計算されます。</p>
                  <section class="sec_option_service">
                    <ul class="lst_option_service">
                      <li v-for="(item,index) in optionServiceList" :key="index">
                        <div>
                          <div class="fl_input">
                            <div class="option_check_wrap">
                              <span class="ins_check_box">
                                <input type="checkbox" v-bind:id="'check_receive' + index" class="chk" v-bind:value="item.key" v-model="orderInput.optionServices">
                                <label v-bind:for="'check_receive' + index" class="lbl_chk"></label>
                                <span>{{item.optionName}}</span>
                              </span>
                            </div>
                          </div>
                          <div class="fr_input option_service_btn_div" @click="optionClick(item.key + index)"></div>
                          <div class="fr_input">{{formatPrice(item.price)}}</div>
                          <div class="cb"></div>
                        </div>
                        <div class="answer_wrap" v-bind:id="item.key + index">
                          <p class="answer">
                            {{item.text}}
                          </p>
                        </div>
                      </li>
                    </ul>
                  </section>
                  <p class="text_p">業者情報：</p>
                  <p class="text_p">{{orderInfo.contractorName}}</p>
                  <p class="text_p">{{orderInfo.contractorAddress}}</p>
                  <div class="subtotal_div">
                    <label>小計</label><div class="subtotal">{{formatPrice(optionPriceTotal)}}</div>
                    <!-- <label>小計</label><div class="subtotal">{{formatPrice(orderInfo.opPrice)}}</div> -->
                  </div>
                </div>
              </li>
              <li>
                <div class="item">
                  <label>【お届け先】</label>
                </div>
                <div class="cnt">
                  <p class="att"><strong class="req">お届け先を変更する場合は編集してください。</strong></p>
                  <div v-if="errorMessage.text"><label class="error_text">{{ errorMessage.text }}</label></div>
                  <div v-if="errors.postcd"><label class="error_text">{{ errors.postcd }}</label></div>
                  <div v-if="errors.prefecture"><label class="error_text">{{ errors.prefecture }}</label></div>
                  <div v-if="errors.address1"><label class="error_text">{{ errors.address1 }}</label></div>
                  <div v-if="errors.address2"><label class="error_text">{{ errors.address2 }}</label></div>
                  <div v-if="errors.address3"><label class="error_text">{{ errors.address3 }}</label></div>
                  <div v-if="errors.cellphoneNo"><label class="error_text">{{ errors.cellphoneNo }}</label></div>
                  <div v-if="errors.contactphoneNo"><label class="error_text">{{ errors.contactphoneNo }}</label></div>
                  <div v-if="errors.deliLastName"><label class="error_text">{{ errors.deliLastName }}</label></div>
                  <div v-if="errors.deliFirstName"><label class="error_text">{{ errors.deliFirstName }}</label></div>
                  <div v-if="errors.deliLastNameKana"><label class="error_text">{{ errors.deliLastNameKana }}</label></div>
                  <div v-if="errors.deliFirstNameKana"><label class="error_text">{{ errors.deliFirstNameKana }}</label></div>
                  <div v-if="errors.floor"><label class="error_text">{{ errors.floor }}</label></div>
                  <div v-if="errors.elevator"><label class="error_text">{{ errors.elevator }}</label></div>
                  <div v-if="errors.deliParkingSpace"><label class="error_text">{{ errors.deliParkingSpace }}</label></div>
                  <div v-if="errors.deliDisposal"><label class="error_text">{{ errors.deliDisposal }}</label></div>
                  <div class="input_div">
                    <div class="item_name_div">
                      <div class="item_name"><span>郵便番号：</span></div>
                      <div class="item_name"><span>都道府県：</span></div>
                      <div class="item_name_3s"><span>住所：</span></div>
                      <div class="item_name"><span>携帯電話番号：</span></div>
                      <div class="item_name"><span>日中ご連絡のとれる電話番号：</span></div>
                      <div class="item_name"><span>お名前(漢字)：</span></div>
                      <div class="item_name"><span>お名前(カナ)：</span></div>
                      <div class="item_name"><span>設置場所の階数：</span></div>
                      <div class="item_name"><span>エレベーター：</span></div>
                      <div class="item_name"><span>駐車スペース：</span></div>
                      <div class="item_name"><span>家具の引き取り：</span></div>
                    </div>
                    <div class="input_item_div">
                      <div class="input_item">
                        <input type="text" class="int fl_input small_input" @keypress="validateNumber" maxlength="3" v-model="orderInput.postcd1" @input="orderInput.postcd1=convertHalfNumber($event)">
                        <div class="fl_input input_interval_div">&nbsp;-&nbsp;</div>
                        <input type="text" class="int fl_input small_input" @keypress="validateNumber" maxlength="4" v-model="orderInput.postcd2" @input="orderInput.postcd2=convertHalfNumber($event)">
                        <div class="fl_input input_interval_div">&nbsp;&nbsp;&nbsp;</div>
                        <div class="fl_input">
                          <a class="small_btn" @click="btnAddressInputClick()">住所自動入力</a>
                        </div>
                        <div class="cb"></div>
                      </div>
                      <div class="input_item">
                        <select id="prefecture" name="prefecture" class="sel" v-model="orderInput.prefecture">
                          <option value=""></option>
                          <option v-for="(item,index) in prefecture" :key="index" >{{item}}</option>
                        </select>
                      </div>
                      <div class="input_item_3s">
                        <input type="text" class="int mb_input" v-model="orderInput.address1">
                        <input type="text" class="int mb_input" v-model="orderInput.address2">
                        <input type="text" class="int mb_input" v-model="orderInput.address3">
                      </div>
                      <div class="input_item">
                        <input type="text" class="int fl_input small_input" @keypress="validateNumber" maxlength="3" v-model="orderInput.cellphoneNo1" @input="orderInput.cellphoneNo1=convertHalfNumber($event)">
                        <div class="fl_input input_interval_div">&nbsp;-&nbsp;</div>
                        <input type="text" class="int fl_input small_input" @keypress="validateNumber" maxlength="4" v-model="orderInput.cellphoneNo2" @input="orderInput.cellphoneNo2=convertHalfNumber($event)">
                        <div class="fl_input input_interval_div">&nbsp;-&nbsp;</div>
                        <input type="text" class="int fl_input small_input" @keypress="validateNumber" maxlength="4" v-model="orderInput.cellphoneNo3" @input="orderInput.cellphoneNo3=convertHalfNumber($event)">
                        <div class="cb"></div>
                      </div>
                      <div class="input_item">
                        <input type="text" class="int fl_input small_input" @keypress="validateNumber" maxlength="3" v-model="orderInput.contactphoneNo1" @input="orderInput.contactphoneNo1=convertHalfNumber($event)">
                        <div class="fl_input input_interval_div">&nbsp;-&nbsp;</div>
                        <input type="text" class="int fl_input small_input" @keypress="validateNumber" maxlength="4" v-model="orderInput.contactphoneNo2" @input="orderInput.contactphoneNo2=convertHalfNumber($event)">
                        <div class="fl_input input_interval_div">&nbsp;-&nbsp;</div>
                        <input type="text" class="int fl_input small_input" @keypress="validateNumber" maxlength="4" v-model="orderInput.contactphoneNo3" @input="orderInput.contactphoneNo3=convertHalfNumber($event)">
                        <div class="cb"></div>
                      </div>
                      <div class="input_item">
                        <input type="text" class="int fl_input pair_input" v-model="orderInput.deliLastName">
                        <div class="pair_input_interval_div fl_input"></div>
                        <input type="text" class="int fl_input pair_input" v-model="orderInput.deliFirstName">
                        <div class="cb"></div>
                      </div>
                      <div class="input_item">
                        <input type="text" class="int fl_input pair_input" v-model="orderInput.deliLastNameKana">
                        <div class="pair_input_interval_div fl_input"></div>
                        <input type="text" class="int fl_input pair_input" v-model="orderInput.deliFirstNameKana">
                        <div class="cb"></div>
                      </div>
                      <div class="input_item">
                        <select id="floor" name="floor" class="sel fl_input pair_input" v-model="orderInput.floor">
                          <option v-for="(item,index) in floorList" :key="index" v-bind:value="item">{{item}}</option>
                          <!-- <option value=""></option>
                          <option v-for="(n,index) in floorUpperLimit - 1" :key="index" v-bind:value="n.toString()">{{n + '階'}}</option>
                          <option v-bind:value="floorUpperLimit.toString()">{{floorUpperLimit}}階以上</option> -->
                        </select>
                        <div class="pair_input_interval_div fl_input"></div>
                        <div class="input_interval_div fl_input"><span>階</span></div>
                        <div class="cb"></div>
                      </div>
                      <div class="input_item">
                        <input v-model="orderInput.elevator" type="radio" id="elevator_Y" name="elevator" value="true" class="rad"><label for="elevator_Y" class="lbl_rad">あり</label>
                        <input v-model="orderInput.elevator" type="radio" id="elevator_N" name="elevator" value="false" class="rad"><label for="elevator_N" class="lbl_rad">なし</label>
                      </div>
                      <div class="input_item">
                        <input v-model="orderInput.deliParkingSpace" type="radio" id="deliParkingSpace_Y" name="deliParkingSpace" value="true" class="rad"><label for="deliParkingSpace_Y" class="lbl_rad">あり</label>
                        <input v-model="orderInput.deliParkingSpace" type="radio" id="deliParkingSpace_N" name="deliParkingSpace" value="false" class="rad"><label for="deliParkingSpace_N" class="lbl_rad">なし</label>
                      </div>
                      <div class="input_item">
                        <input v-model="orderInput.deliDisposal" type="radio" id="deliDisposal_Y" name="deliDisposal" value="true" class="rad"><label for="deliDisposal_Y" class="lbl_rad">あり</label>
                        <input v-model="orderInput.deliDisposal" type="radio" id="deliDisposal_N" name="deliDisposal" value="false" class="rad"><label for="deliDisposal_N" class="lbl_rad">なし</label>
                      </div>
                    </div>
                    <div class="cb"></div>
                  </div>
                  <div class="subtotal_div">
                    <label>搬送搬入費用</label><div class="subtotal">{{formatPrice(0)}}</div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item">
                  <label>【お届け希望日】</label>
                </div>
                <div class="cnt">
                  <div v-if="errors.deliveryPref"><label class="error_text">{{ errors.deliveryPref }}</label></div>
                  <!-- <div v-if="errors.deliveryYmd"><label class="error_text">{{ errors.deliveryYmd }}</label></div> -->
                  <div v-if="errors.deliveryTime"><label class="error_text">{{ errors.deliveryTime }}</label></div>
                  <div class="preferred_day_div">
                    <div class="calendar_div">
                      <kg-calendar
                        :schedule="deliverySchedule"
                        :value="orderInput.deliveryPref"
                        :name="'deliveryPref'"
                        @selectedDate="selectedDate"
                      />
                    </div>
                    <!-- TODO 一旦プルダウンを閉じる
                      <br/>
                      <select name="bir_yy" class="sel prefYearInput fl_input" v-model="orderInput.deliveryYear">
                        <option v-for="(y,index) in yearLimit - yearOffset" :key="index" v-bind:value="y + yearOffset">{{y + yearOffset}}</option>
                      </select>
                      <span class="unit fl_input">年</span>
                      <select name="bir_mm" class="sel prefDateInput fl_input" v-model="orderInput.deliveryMonth">
                        <option v-for="(m,index) in 12" :key="index" v-bind:value="m">{{m}}</option>
                      </select>
                      <span class="unit fl_input">月</span>
                      <select name="bir_dd" class="sel prefDateInput fl_input" v-model="orderInput.deliveryDay">
                        <option v-for="(d,index) in 31" :key="index" v-bind:value="d">{{d}}</option>
                      </select>
                      <span class="unit fl_input">日</span>
                      <select name="bir_time" class="sel time_select fl_input" v-model="orderInput.deliveryTime">
                        <option v-for="(t,index) in timeList" :key="index" v-bind:value="t">{{t}}</option>
                      </select>
                    -->
                    <div class="cb"></div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item">
                  <label>【組立作業希望日】</label>
                </div>
                <p class="att"><strong class="req">※担当者からご連絡いたします。</strong></p>
                <div class="cnt">
                  <div v-if="errors.btPref1"><label class="error_text">{{ errors.btPref1 }}</label></div>
                  <div v-if="errors.btPref2"><label class="error_text">{{ errors.btPref2 }}</label></div>
                  <div v-if="errors.btPref3"><label class="error_text">{{ errors.btPref3 }}</label></div>
                  <!-- <div v-if="errors.btPref1Ymd"><label class="error_text">{{ errors.btPref1Ymd }}</label></div>
                  <div v-if="errors.btPref2Ymd"><label class="error_text">{{ errors.btPref2Ymd }}</label></div>
                  <div v-if="errors.btPref3Ymd"><label class="error_text">{{ errors.btPref3Ymd }}</label></div> -->
                  <div v-if="errors.btPref1Time"><label class="error_text">{{ errors.btPref1Time }}</label></div>
                  <div v-if="errors.btPref2Time"><label class="error_text">{{ errors.btPref2Time }}</label></div>
                  <div v-if="errors.btPref3Time"><label class="error_text">{{ errors.btPref3Time }}</label></div>
                  <div class="preferred_day_div">
                    <label>第一希望:</label>
                    <div>
                      <div class="calendar_div">
                        <kg-calendar
                          :schedule="constructSchedule"
                          :value="orderInput.btPref1"
                          :name="'btPref1'"
                          @selectedDate="selectedDate"
                        />
                      </div>
                      <!-- TODO 一旦プルダウンを閉じる
                        <br/>
                        <select name="bir_yy" class="sel prefYearInput fl_input" v-model="orderInput.btPref1Year">
                          <option v-for="(y,index) in yearLimit - yearOffset" :key="index" v-bind:value="y + yearOffset">{{y + yearOffset}}</option>
                        </select>
                        <span class="unit fl_input">年</span>
                        <select name="bir_mm" class="sel prefDateInput fl_input" v-model="orderInput.btPref1Month">
                          <option v-for="(m,index) in 12" :key="index" v-bind:value="m">{{m}}</option>
                        </select>
                        <span class="unit fl_input">月</span>
                        <select name="bir_dd" class="sel prefDateInput fl_input" v-model="orderInput.btPref1Day">
                          <option v-for="(d,index) in 31" :key="index" v-bind:value="d">{{d}}</option>
                        </select>
                        <span class="unit fl_input">日</span>
                        <select name="bir_time" class="sel time_select fl_input" v-model="orderInput.btPref1Time">
                          <option v-for="(t,index) in timeList" :key="index" v-bind:value="t">{{t}}</option>
                        </select>
                      -->
                      <div class="cb"></div>
                    </div>
                  </div>
                  <div class="preferred_day_div">
                    <label>第二希望:</label>
                    <div>
                      <div class="calendar_div">
                        <kg-calendar
                          :schedule="constructSchedule"
                          :value="orderInput.btPref2"
                          :name="'btPref2'"
                          @selectedDate="selectedDate"
                        />
                      </div>
                      <!-- TODO 一旦プルダウンを閉じる
                        <br/>
                        <select name="bir_yy" class="sel prefYearInput fl_input" v-model="orderInput.btPref2Year">
                          <option v-for="(y,index) in yearLimit - yearOffset" :key="index" v-bind:value="y + yearOffset">{{y + yearOffset}}</option>
                        </select>
                        <span class="unit fl_input">年</span>
                        <select name="bir_mm" class="sel prefDateInput fl_input" v-model="orderInput.btPref2Month">
                          <option v-for="(m,index) in 12" :key="index" v-bind:value="m">{{m}}</option>
                        </select>
                        <span class="unit fl_input">月</span>
                        <select name="bir_dd" class="sel prefDateInput fl_input" v-model="orderInput.btPref2Day">
                          <option v-for="(d,index) in 31" :key="index" v-bind:value="d">{{d}}</option>
                        </select>
                        <span class="unit fl_input">日</span>
                        <select name="bir_time" class="sel time_select fl_input" v-model="orderInput.btPref2Time">
                          <option v-for="(t,index) in timeList" :key="index" v-bind:value="t">{{t}}</option>
                        </select>
                      -->
                      <div class="cb"></div>
                    </div>
                  </div>
                  <div class="preferred_day_div">
                    <label>第三希望:</label>
                    <div>
                      <div class="calendar_div">
                        <kg-calendar
                          :schedule="constructSchedule"
                          :value="orderInput.btPref3"
                          :name="'btPref3'"
                          @selectedDate="selectedDate"
                        />
                      </div>
                      <!-- TODO 一旦プルダウンを閉じる
                        <br/>
                        <select name="bir_yy" class="sel prefYearInput fl_input" v-model="orderInput.btPref3Year">
                          <option v-for="(y,index) in yearLimit - yearOffset" :key="index" v-bind:value="y + yearOffset">{{y + yearOffset}}</option>
                        </select>
                        <span class="unit fl_input">年</span>
                        <select name="bir_mm" class="sel prefDateInput fl_input" v-model="orderInput.btPref3Month">
                          <option v-for="(m,index) in 12" :key="index" v-bind:value="m">{{m}}</option>
                        </select>
                        <span class="unit fl_input">月</span>
                        <select name="bir_dd" class="sel prefDateInput fl_input" v-model="orderInput.btPref3Day">
                          <option v-for="(d,index) in 31" :key="index" v-bind:value="d">{{d}}</option>
                        </select>
                        <span class="unit fl_input">日</span>
                        <select name="bir_time" class="sel time_select fl_input" v-model="orderInput.btPref3Time">
                          <option v-for="(t,index) in timeList" :key="index" v-bind:value="t">{{t}}</option>
                        </select>
                      -->
                      <div class="cb"></div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div v-if="errorMessage.text"><label class="error_text">{{ errorMessage.text }}</label></div>
            <div v-if="errors.postcd"><label class="error_text">{{ errors.postcd }}</label></div>
            <div v-if="errors.prefecture"><label class="error_text">{{ errors.prefecture }}</label></div>
            <div v-if="errors.address1"><label class="error_text">{{ errors.address1 }}</label></div>
            <div v-if="errors.address2"><label class="error_text">{{ errors.address2 }}</label></div>
            <div v-if="errors.address3"><label class="error_text">{{ errors.address3 }}</label></div>
            <div v-if="errors.cellphoneNo"><label class="error_text">{{ errors.cellphoneNo }}</label></div>
            <div v-if="errors.contactphoneNo"><label class="error_text">{{ errors.contactphoneNo }}</label></div>
            <div v-if="errors.deliLastName"><label class="error_text">{{ errors.deliLastName }}</label></div>
            <div v-if="errors.deliFirstName"><label class="error_text">{{ errors.deliFirstName }}</label></div>
            <div v-if="errors.deliLastNameKana"><label class="error_text">{{ errors.deliLastNameKana }}</label></div>
            <div v-if="errors.deliFirstNameKana"><label class="error_text">{{ errors.deliFirstNameKana }}</label></div>
            <div v-if="errors.floor"><label class="error_text">{{ errors.floor }}</label></div>
            <div v-if="errors.elevator"><label class="error_text">{{ errors.elevator }}</label></div>
            <div v-if="errors.deliParkingSpace"><label class="error_text">{{ errors.deliParkingSpace }}</label></div>
            <div v-if="errors.deliDisposal"><label class="error_text">{{ errors.deliDisposal }}</label></div>
            <div v-if="errors.deliveryPref"><label class="error_text">{{ errors.deliveryPref }}</label></div>
            <div v-if="errors.btPref1"><label class="error_text">{{ errors.btPref1 }}</label></div>
            <div v-if="errors.btPref2"><label class="error_text">{{ errors.btPref2 }}</label></div>
            <div v-if="errors.btPref3"><label class="error_text">{{ errors.btPref3 }}</label></div>
            <!-- <div v-if="errors.deliveryYmd"><label class="error_text">{{ errors.deliveryYmd }}</label></div>
            <div v-if="errors.btPref1Ymd"><label class="error_text">{{ errors.btPref1Ymd }}</label></div>
            <div v-if="errors.btPref2Ymd"><label class="error_text">{{ errors.btPref2Ymd }}</label></div>
            <div v-if="errors.btPref3Ymd"><label class="error_text">{{ errors.btPref3Ymd }}</label></div> -->
            <div v-if="errors.deliveryTime"><label class="error_text">{{ errors.deliveryTime }}</label></div>
            <div v-if="errors.btPref1Time"><label class="error_text">{{ errors.btPref1Time }}</label></div>
            <div v-if="errors.btPref2Time"><label class="error_text">{{ errors.btPref2Time }}</label></div>
            <div v-if="errors.btPref3Time"><label class="error_text">{{ errors.btPref3Time }}</label></div>
            <div v-for="(item,index) in validateErrorMessages" :key="index" class="error_text">{{item}}</div>
            <div class="btn_area">
              <a class="btn1" @click="btnOrderClick()">オーダーする</a>
            </div>
            <!-- TODO デバッグ用 -->
            <div class="btn_area" v-if="userInfo.userDebugFlg">
              <a class="btn1" @click="debugOrder()">オーダーする(デバッグ用)</a>
            </div>
            <!-- TODO デバッグ用 -->
            <div class="btn_area" v-if="userInfo.userDebugFlg">
              <a class="btn1" @click="debugSheet()">図面(デバッグ用)</a>
            </div>
          </div>
          <div class="bx_total">
            <ul class="lst_total">
              <li>
                <span class="item">プラン</span><span class="value">{{formatPrice(orderInfo.subTotalPrice)}}</span>
              </li>
              <li>
                <span class="item">オプションサービス</span><span class="value">{{formatPrice(optionPriceTotal)}}</span>
              </li>
              <li>
                <span class="item">搬送搬入費用</span><span class="value">{{formatPrice(orderInfo.deliveryPrice)}}</span>
              </li>
              <li>
                <span class="item">消費税(10%)</span><span class="value">{{formatPrice(taxPrice)}}</span>
              </li>
            </ul>
            <div class="ft_total">
              <a class="btn_msg" @click="presentationSheet()">カグルシートを作成する</a>
              <dl class="total_price">
                <dt>合計</dt><dd><strong>{{formatPrice(priceTotal)}}</strong></dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <kg-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'
// import {KG_URL, KG_STORAGE_KEY} from '../../constants/App'
import {KG_URL, KG_STORAGE_KEY} from '../../constants/App'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as Check from '../../utils/Check'
import * as FormUtil from '../../utils/FormUtil'
import * as Calc from '../../utils/Calc'

// kaggul Module
import Calendar from '../../components/common/Calendar'
import Header from '../components/common/HomeIconHeader'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  components: {
    'kg-header': Header,
    'kg-calendar': Calendar,
    'kg-loading-modal': LoadingModal
  },
  data () {
    return {
      // サーバーから取得したオーダー情報
      orderInfo: {
        productName: '',
        orderNo: '',
        producerName: '',
        producerAddress: '',
        subTotalPrice: 0,
        deliveryPrice: 0,
        contractorName: '',
        contractorAddress: '',
        combineList: [],
        unitList: [],
        opServiceList: [],
        planContents: {},
        combineContentsList: []
      },
      // 入力したオーダー情報
      orderInput: {
        optionServices: [],
        postcd1: '',
        postcd2: '',
        prefecture: '',
        address1: '',
        address2: '',
        address3: '',
        cellphoneNo1: '',
        cellphoneNo2: '',
        cellphoneNo3: '',
        contactphoneNo1: '',
        contactphoneNo2: '',
        contactphoneNo3: '',
        deliLastName: '',
        deliFirstName: '',
        deliLastNameKana: '',
        deliFirstNameKana: '',
        floor: '5',
        elevator: true,
        deliParkingSpace: true,
        deliDisposal: false,
        deliveryYear: '',
        deliveryMonth: '',
        deliveryDay: '',
        deliveryTime: 'AM10:00',
        btPref1Year: '',
        btPref1Month: '',
        btPref1Day: '',
        btPref1Time: 'AM10:00',
        btPref2Year: '',
        btPref2Month: '',
        btPref2Day: '',
        btPref2Time: 'AM10:00',
        btPref3Year: '',
        btPref3Month: '',
        btPref3Day: '',
        btPref3Time: 'AM10:00',
        deliveryPref: '',
        btPref1: '',
        btPref2: '',
        btPref3: ''
      },
      deliverySchedule: {},
      constructSchedule: {},
      prefecture: [
        '北海道', '青森県', '岩手県', '宮城県',
        '秋田県', '山形県', '福島県', '茨城県', '栃木県',
        '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
        '新潟県', '富山県', '石川県', '福井県', '山梨県',
        '長野県', '岐阜県', '静岡県', '愛知県', '三重県',
        '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県',
        '和歌山県', '鳥取県', '島根県', '岡山県', '広島県',
        '山口県', '徳島県', '香川県', '愛媛県', '高知県',
        '福岡県', '佐賀県', '長崎県', '熊本県', '大分県',
        '宮崎県', '鹿児島県', '沖縄県'
      ],
      optionServiceList: [
        {key: 'option1', optionName: '採寸・現調', price: 20000, text: '採寸・現調の説明文'},
        {key: 'option2', optionName: '組立・設置', price: 5000, text: '組立・設置の説明文'},
        {key: 'option3', optionName: '施工 (壁面固定)', price: 10000, text: '製品化されたお客様のオーダー家具を、お住まいの設置場所へ大切に設置加工を致します。施工管理はもちろん、ご近所への挨拶や美化など、きめ細やかな対応を心がけます。お客様がご注文したオーダー家具は、熟練した木工技能士により製造加工し、製品化されます。少しの妥協も許さない徹底したクオリティーを維持しております。'},
        {key: 'option4', optionName: '穴あけ加工', price: 10000, text: '穴あけ加工の説明文'},
        {key: 'option5', optionName: '転倒防止', price: 10000, text: '転倒防止の説明文'}
      ],
      floorList: [
        '50',
        '49',
        '48',
        '47',
        '46',
        '45',
        '44',
        '43',
        '42',
        '41',
        '40',
        '39',
        '38',
        '37',
        '36',
        '35',
        '34',
        '33',
        '32',
        '31',
        '30',
        '29',
        '28',
        '27',
        '26',
        '25',
        '24',
        '23',
        '22',
        '21',
        '20',
        '19',
        '18',
        '17',
        '16',
        '15',
        '14',
        '13',
        '12',
        '11',
        '10',
        '9',
        '8',
        '7',
        '6',
        '5',
        '4',
        '3',
        '2',
        '1',
        'B1',
        'B2'
      ],
      timeList: [
        'AM',
        'PM'
        // 'AM5:00',
        // 'AM6:00',
        // 'AM7:00',
        // 'AM8:00',
        // 'AM9:00',
        // 'AM10:00',
        // 'AM11:00',
        // 'PM12:00',
        // 'PM13:00',
        // 'PM14:00',
        // 'PM15:00',
        // 'PM16:00',
        // 'PM17:00',
        // 'PM18:00',
        // 'PM19:00以降'
      ],
      errors: {},
      submitDisable: false,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateErrorMessages: {},
      /** サーバーから見積情報を取得が完了したかのフラグ */
      isGetEstimate: false,
      userInfo: {}
    }
  },
  methods: {
    scheduling: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios.get(KG_URL.SCHEDULE + '/delivery')
        .then(response => {
          this.deliverySchedule = response.data.data
          this.getConstructSchedule(this.orderInput.deliveryPref)
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/kagull/error')
        })
    },
    getConstructSchedule: function (newDate) {
      let payload = {
        params: {
          deliveryDate: newDate
        }
      }
      axios.get(KG_URL.SCHEDULE + '/construct', payload)
        .then(response => {
          this.constructSchedule = response.data.data
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/kagull/error')
        }).finally(() => {
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    fetchData: function () {
      // 入力したオーダー情報
      let orderInput = App.getLocalStorage(KG_STORAGE_KEY.ORDER_INPUT)
      if (Object.keys(orderInput).length > 0) {
        this.orderInput = Object.assign({}, orderInput)
      }

      // オプションサービスリスト
      let optionServiceList = App.getLocalStorage(KG_STORAGE_KEY.OPTION_SERVICE_LIST)
      if (Object.keys(optionServiceList).length > 0) {
        this.optionServiceList = optionServiceList.slice(0, optionServiceList.length)
      }

      // サーバーから取得したオーダー情報
      let orderInfo = App.getLocalStorage(KG_STORAGE_KEY.ORDER_INFO)
      if (Object.keys(orderInfo).length > 0) {
        this.orderInfo = Object.assign({}, orderInfo)
        this.isGetEstimate = true
      } else {
        axios.get(KG_URL.ORDER + '/get-estimate')
          .then(response => {
            if (response.data.errorMessage) {
              this.handleErrorMessage(response)
            } else {
              console.log(response.data.data)
              this.orderInfo = response.data.data
            }
            this.isGetEstimate = true
          }).catch(error => {
            Api.handleError(error)
          })
      }
    },
    btnOrderClick: function () {
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)
      this.errorMessage.text = ''
      this.validateErrorMessages = {}
      this.errors = {}
      this.validate()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        this.submitDisable = false
        return
      }
      let payload = {
        optionServices: this.orderInput.optionServices,
        opPrice: this.optionPriceTotal,
        deliPostcd: this.postcd,
        deliState: this.orderInput.prefecture,
        deliCity: this.orderInput.address1,
        deliStreet: this.orderInput.address2,
        deliBuilding: this.orderInput.address3,
        deliCellPhoneNo: this.cellphoneNo,
        deliTel: this.contactphoneNo,
        deliLastName: this.orderInput.deliLastName,
        deliFirstName: this.orderInput.deliFirstName,
        deliLastNameKana: this.orderInput.deliLastNameKana,
        deliFirstNameKana: this.orderInput.deliFirstNameKana,
        deliFloor: this.orderInput.floor,
        deliElevator: this.orderInput.elevator,
        deliParkingSpace: this.orderInput.deliParkingSpace,
        deliDisposal: this.orderInput.deliDisposal,
        deliPref: this.orderInput.deliveryPref,
        // deliPref: this.yyyyMMddDeliPref,
        deliPrefTime: this.orderInput.deliveryTime,
        btPref1: this.orderInput.btPref1,
        // btPref1: this.yyyyMMddBtPref1,
        btPref1Time: this.orderInput.btPref1Time,
        btPref2: this.orderInput.btPref2,
        // btPref2: this.yyyyMMddBtPref2,
        btPref2Time: this.orderInput.btPref2Time,
        btPref3: this.orderInput.btPref3,
        // btPref3: this.yyyyMMddBtPref3,
        btPref3Time: this.orderInput.btPref3Time
      }
      axios.post(KG_URL.ORDER + '/input', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            console.log(response.data.errorMessage)
          } else {
            console.log(response.data.data)
            App.setLocalStorage(KG_STORAGE_KEY.ORDER_INFO, this.orderInfo)
            App.setLocalStorage(KG_STORAGE_KEY.ORDER_INPUT, this.orderInput)
            App.setLocalStorage(KG_STORAGE_KEY.OPTION_SERVICE_LIST, this.optionServiceList)
            this.$router.push({
              name: 'KgOrderConfirm'
            })
          }
          this.$refs.loadingModalRef.showModal(false)
          this.submitDisable = false
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.submitDisable = false
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          console.log(this.validateErrorMessages)
        })
    },
    btnAddressInputClick: function () {
      // 郵便番号から住所を補完する
      FormUtil.addressCompletion(this.postcd, (address) => {
        this.$set(this.orderInput, 'prefecture', address.state)
        this.$set(this.orderInput, 'address1', address.city)
        this.$set(this.orderInput, 'address2', address.street)
      })
    },
    btnCombineClick: function (targetId) {
      // ユニット情報の表示非表示切り替え
      let target = document.getElementById(targetId)
      if (target.style.display === 'block') {
        target.style.display = 'none'
      } else {
        target.style.display = 'block'
      }
      if (target.parentElement.classList.contains('active')) {
        target.parentElement.classList.remove('active')
      } else {
        target.parentElement.classList.add('active')
      }
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    convertHalfNumber: function (event) {
      // 郵便番号や電話番号で最初に0がくる場合があるため別で用意
      let str = FormUtil.restHalfNumber(event.target.value)
      return str
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    formatOrderNo: function (orderNo) {
      if (!orderNo) return ''
      return orderNo.substring(0, 3) + '-' + orderNo.substring(3, 7) + '-' + orderNo.substring(8)
    },
    roundPrice: function (value) {
      return Calc.round(value, 0)
    },
    optionClick: function (targetId) {
      // オプションサービス説明の表示非表示切り替え
      let target = document.getElementById(targetId)
      if (target.style.display === 'block') {
        target.style.display = 'none'
      } else {
        target.style.display = 'block'
      }
      if (target.parentElement.classList.contains('active')) {
        target.parentElement.classList.remove('active')
      } else {
        target.parentElement.classList.add('active')
      }
    },
    validate: function () {
      // 入力チェック
      if (!this.orderInput.postcd1 || !this.orderInput.postcd2) {
        this.errors['postcd'] = '郵便番号が未入力です。'
      }
      if (!this.orderInput.prefecture) {
        this.errors['prefecture'] = '都道府県が未入力です。'
      }
      if (!this.orderInput.address1 || !this.orderInput.address1.trim()) {
        this.errors['address1'] = '市町村が未入力です。'
      }
      if (!this.orderInput.address2 || !this.orderInput.address2.trim()) {
        this.errors['address2'] = '住所/番地が未入力です。'
      }
      if (!this.orderInput.cellphoneNo1 || !this.orderInput.cellphoneNo2 || !this.orderInput.cellphoneNo3) {
        this.errors['cellphoneNo'] = '携帯電話番号が未入力です。'
      }
      if (!this.orderInput.contactphoneNo1 || !this.orderInput.contactphoneNo2 || !this.orderInput.contactphoneNo3) {
        this.errors['contactphoneNo'] = 'ご連絡のとれる電話番号が未入力です。'
      }
      if (!this.orderInput.deliLastName || !this.orderInput.deliLastName.trim()) {
        this.errors['deliLastName'] = 'お名前(漢字)姓が未入力です。'
      }
      if (!this.orderInput.deliFirstName || !this.orderInput.deliFirstName.trim()) {
        this.errors['deliFirstName'] = 'お名前(漢字)名が未入力です。'
      }
      if (!this.orderInput.deliLastNameKana || !this.orderInput.deliLastNameKana.trim()) {
        this.errors['deliLastNameKana'] = 'お名前(カナ)姓が未入力です。'
      }
      if (!this.orderInput.deliFirstNameKana || !this.orderInput.deliFirstNameKana.trim()) {
        this.errors['deliFirstNameKana'] = 'お名前(カナ)名が未入力です。'
      }
      if (!this.orderInput.floor) {
        this.errors['floor'] = 'お住まいの階数が未入力です。'
      }
      if (this.orderInput.elevator == null) {
        this.errors['elevator'] = 'エレベーター有無が未入力です。'
      }
      if (this.orderInput.deliParkingSpace == null) {
        this.errors['deliParkingSpace'] = '駐車スペース有無が未入力です。'
      }
      if (this.orderInput.deliDisposal == null) {
        this.errors['deliDisposal'] = '家具の引き取り有無が未入力です。'
      }
      if (!this.orderInput.deliveryPref) {
        this.errors['deliveryPref'] = 'お届け希望日が未入力です。'
      }
      if (!this.orderInput.btPref1) {
        this.errors['btPref1'] = '組立作業第一希望日が未入力です。'
      }
      if (!this.orderInput.btPref2) {
        this.errors['btPref2'] = '組立作業第二希望日が未入力です。'
      }
      if (!this.orderInput.btPref3) {
        this.errors['btPref3'] = '組立作業第三希望日が未入力です。'
      }
      // プルダウンの年月日が不要になった場合は以下チェックは不要
      // if (!this.orderInput.deliveryYear || !this.orderInput.deliveryMonth || !this.orderInput.deliveryDay) {
      //   this.errors['deliveryYmd'] = 'お届け希望日が未入力です。'
      // }
      // if (!this.orderInput.btPref1Year || !this.orderInput.btPref1Month || !this.orderInput.btPref1Day) {
      //   this.errors['btPref1Ymd'] = '組立作業第一希望日が未入力です。'
      // }
      // if (!this.orderInput.btPref2Year || !this.orderInput.btPref2Month || !this.orderInput.btPref2Day) {
      //   this.errors['btPref2Ymd'] = '組立作業第二希望日が未入力です。'
      // }
      // if (!this.orderInput.btPref3Year || !this.orderInput.btPref3Month || !this.orderInput.btPref3Day) {
      //   this.errors['btPref3Ymd'] = '組立作業第三希望日が未入力です。'
      // }
      // ここまで
      if (!this.orderInput.deliveryTime) {
        this.errors['deliveryTime'] = 'お届け希望時刻が未入力です。'
      }
      if (!this.orderInput.btPref1Time) {
        this.errors['btPref1Time'] = '組立作業第一希望時刻が未入力です。'
      }
      if (!this.orderInput.btPref2Time) {
        this.errors['btPref2Time'] = '組立作業第二希望時刻が未入力です。'
      }
      if (!this.orderInput.btPref3Time) {
        this.errors['btPref3Time'] = '組立作業第三希望時刻が未入力です。'
      }
    },
    yyyyMMddMake: function (yStr, mStr, dStr) {
      if (yStr.length <= 0 || mStr.length <= 0 || dStr.length <= 0) {
        return ''
      }
      let m = mStr
      if (m.length === 1) {
        m = '0' + m
      }
      let d = dStr
      if (d.length === 1) {
        d = '0' + d
      }
      return yStr + m + d
    },
    dateFormat: function (selectedDate) {
      let format = 'YYYY-MM-dd'.replace(/YYYY/g, selectedDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (selectedDate.getMonth() + 1)).slice(-2))
      format = format.replace(/dd/g, ('0' + selectedDate.getDate()).slice(-2))
      return format
    },
    selectedDate: function (name, selectedDate) {
      console.log(selectedDate)
      // カレンダーの選択値を受け取り設定する
      if (!selectedDate) {
        return
      }
      if (typeof (selectedDate) === 'string' || selectedDate instanceof String) {
        selectedDate = new Date(selectedDate)
      }
      let format = this.dateFormat(selectedDate)
      console.log(format)
      this.orderInput[name] = format
    },
    handleErrorMessage: function (response) {
      if (!response || !response.data) {
        return
      }
      let modalData = {
        title: 'エラー',
        messages: response.data.errorMessage.split(/\r?\n/g),
        messageType: 'error',
        textAlign: 'left'
      }
      App.showModal(modalData)
    },
    getPlanImage: function () {
      let planContents = this.orderInfo.kgCgImageName
      let corpId = this.orderInfo.corpId
      return planContents !== ''
        ? App.getContentsResource(corpId + '/Kagull/' + planContents)
        : App.getKagullResource('noimage.svg')
    },
    getCombineImage: function (combine) {
      let combineContents = this.orderInfo.combineContentsList.find(combineContents => {
        return combineContents.umCode === combine.objUmCode
      })
      return combineContents != null
        ? App.getContentsResource(combineContents.corpId + '/' + combineContents.contentsImgMid)
        : App.getKagullResource('noimage.svg')
    },
    noImage: function (element) {
      element.target.src = App.getKagullResource('noimage.svg')
    },
    // TODO デバッグ用のボタン
    debugOrder: function () {
      this.orderInput.optionServices = []
      this.orderInput.postcd1 = '151'
      this.orderInput.postcd2 = '0053'
      this.orderInput.prefecture = '東京都'
      this.orderInput.address1 = '渋谷区'
      this.orderInput.address2 = '代々木'
      this.orderInput.address3 = ''
      this.orderInput.cellphoneNo1 = '111'
      this.orderInput.cellphoneNo2 = '1111'
      this.orderInput.cellphoneNo3 = '1111'
      this.orderInput.contactphoneNo1 = '222'
      this.orderInput.contactphoneNo2 = '2222'
      this.orderInput.contactphoneNo3 = '2222'
      this.orderInput.deliLastName = '田中'
      this.orderInput.deliFirstName = '太郎'
      this.orderInput.deliLastNameKana = 'タナカ'
      this.orderInput.deliFirstNameKana = 'タロウ'
      this.orderInput.floor = '5'
      this.orderInput.elevator = true
      this.orderInput.deliParkingSpace = true
      this.orderInput.deliDisposal = false
      this.orderInput.deliveryPref = '2021-09-10'
      this.orderInput.deliveryTime = '2021-09-10'
      this.orderInput.btPref1 = '2022-09-10'
      this.orderInput.btPref1Time = '2021-09-10'
      this.orderInput.btPref2 = '2022-09-10'
      this.orderInput.btPref2Time = '2021-09-10'
      this.orderInput.btPref3 = '2022-09-10'
      this.orderInput.btPref3Time = '2021-09-10'

      let payload = {
        optionServices: this.orderInput.optionServices,
        opPrice: this.optionPriceTotal,
        deliPostcd: this.postcd,
        deliState: this.orderInput.prefecture,
        deliCity: this.orderInput.address1,
        deliStreet: this.orderInput.address2,
        deliBuilding: this.orderInput.address3,
        deliCellPhoneNo: this.cellphoneNo,
        deliTel: this.contactphoneNo,
        deliLastName: this.orderInput.deliLastName,
        deliFirstName: this.orderInput.deliFirstName,
        deliLastNameKana: this.orderInput.deliLastNameKana,
        deliFirstNameKana: this.orderInput.deliFirstNameKana,
        deliFloor: this.orderInput.floor,
        deliElevator: this.orderInput.elevator,
        deliParkingSpace: this.orderInput.deliParkingSpace,
        deliDisposal: this.orderInput.deliDisposal,
        deliPref: this.orderInput.deliveryPref,
        // deliPref: this.yyyyMMddDeliPref,
        deliPrefTime: this.orderInput.deliveryTime,
        btPref1: this.orderInput.btPref1,
        // btPref1: this.yyyyMMddBtPref1,
        btPref1Time: this.orderInput.btPref1Time,
        btPref2: this.orderInput.btPref2,
        // btPref2: this.yyyyMMddBtPref2,
        btPref2Time: this.orderInput.btPref2Time,
        btPref3: this.orderInput.btPref3,
        // btPref3: this.yyyyMMddBtPref3,
        btPref3Time: this.orderInput.btPref3Time
      }

      axios.post(KG_URL.ORDER + '/input', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            console.log(response.data.errorMessage)
          } else {
            console.log(response.data.data)
            App.setLocalStorage(KG_STORAGE_KEY.ORDER_INFO, this.orderInfo)
            App.setLocalStorage(KG_STORAGE_KEY.ORDER_INPUT, this.orderInput)
            App.setLocalStorage(KG_STORAGE_KEY.OPTION_SERVICE_LIST, this.optionServiceList)
            this.$router.push({
              name: 'KgOrderConfirm'
            })
          }
          this.$refs.loadingModalRef.showModal(false)
          this.submitDisable = false
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.submitDisable = false
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          console.log(this.validateErrorMessages)
        })
    },
    debugSheet: function () {
      this.$router.push({
        name: 'KgSheetPreview'
      })
    },
    presentationSheet: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios.get(KG_URL.ORDER + '/presentation-sheet')
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            App.showModal({
              title: 'エラー',
              messages: [response.data.errorMessage],
              messageType: 'error'
            })
          } else {
            App.showModal({
              messages: ['※出力物はサーバーにて自動生成完了後、', '登録されたメールアドレス宛に送られます。']
            })
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          console.log(this.error)
        })
    }
  },
  computed: {
    postcd: function () {
      // 郵便番号を連結して返す
      return this.orderInput.postcd1 + this.orderInput.postcd2
    },
    cellphoneNo: function () {
      // 携帯電話番号を連結して返す
      return this.orderInput.cellphoneNo1 + this.orderInput.cellphoneNo2 + this.orderInput.cellphoneNo3
    },
    contactphoneNo: function () {
      // 連絡用電話番号を連結して返す
      return this.orderInput.contactphoneNo1 + this.orderInput.contactphoneNo2 + this.orderInput.contactphoneNo3
    },
    floorUpperLimit: function () {
      // 階数ドロップダウンの最大値を返す
      return 10
    },
    optionPriceTotal: function () {
      // オプションサービスのチェックに応じて小計を計算する
      if (Object.keys(this.orderInput.optionServices).length !== 0) {
        let temp = this.optionServiceList
          .filter(e => this.orderInput.optionServices.includes(e.key))
          .map(e => e.price)
        if (Object.keys(temp).length !== 0) {
          return temp.reduce(function (p, c) { return p + c })
        }
      }
      return 0
    },
    taxPrice: function () {
      let price = this.orderInfo.subTotalPrice + this.optionPriceTotal + this.orderInfo.deliveryPrice
      return Math.ceil(price * 0.1)
    },
    priceTotal: function () {
      // 合計金額を計算する
      return this.orderInfo.subTotalPrice + this.optionPriceTotal + this.orderInfo.deliveryPrice + this.taxPrice
    },
    currentYear: function () {
      return new Date().getFullYear()
    },
    yearOffset: function () {
      // 年選択プルダウンのオフセット
      return this.currentYear - 1
    },
    yearLimit: function () {
      // 年選択プルダウンの最大値
      return this.currentYear + 5
    },
    yyyyMMddDeliPref: function () {
      // お届け希望日をyyyyMMdd形式にして返す
      return this.yyyyMMddMake(this.orderInput.deliveryYear.toString(), this.orderInput.deliveryMonth.toString(), this.orderInput.deliveryDay.toString())
    },
    yyyyMMddBtPref1: function () {
      // 組立作業希望日1をyyyyMMdd形式にして返す
      return this.yyyyMMddMake(this.orderInput.btPref1Year.toString(), this.orderInput.btPref1Month.toString(), this.orderInput.btPref1Day.toString())
    },
    yyyyMMddBtPref2: function () {
      // 組立作業希望日2をyyyyMMdd形式にして返す
      return this.yyyyMMddMake(this.orderInput.btPref2Year.toString(), this.orderInput.btPref2Month.toString(), this.orderInput.btPref2Day.toString())
    },
    yyyyMMddBtPref3: function () {
      // 組立作業希望日3をyyyyMMdd形式にして返す
      return this.yyyyMMddMake(this.orderInput.btPref3Year.toString(), this.orderInput.btPref3Month.toString(), this.orderInput.btPref3Day.toString())
    }
  },
  watch: {
    'orderInput.deliveryPref': function (newDate, oldDate) {
      this.getConstructSchedule(newDate)
    }
  },
  mounted: function () {
    this.scheduling()
    // 仮の値なので後で修正
    // 取得して表示する値があるならばこの関数内で取得して設定する
    // let d = new Date()
    // d.setMonth(d.getMonth() + 1)
    // this.orderInput.deliveryPref = this.dateFormat(d)
    // d.setDate(d.getDate() + 1)
    // this.orderInput.btPref1 = this.dateFormat(d)
    // d.setDate(d.getDate() + 1)
    // this.orderInput.btPref2 = this.dateFormat(d)
    // d.setDate(d.getDate() + 1)
    // this.orderInput.btPref3 = this.dateFormat(d)
  },
  created: function () {
    this.fetchData()
    this.userInfo = App.getLocalStorage(KG_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/OrderInput.vue